import { CityDetailPage } from "@/features/geolocation/page/CityDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/city/$id/detail")({
  component: CityDetailPage,
});
